import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import _ from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { v4 as uuid } from "uuid";

import { Button, DropDownField } from "../../helpers";
import Menu from "../../helpers/Menu"
import { Dialog } from "primereact/dialog";

import Loading from "../../common/Loading";
import ViewAdjustmentNote from '../../common/ViewAdjustmentNote'
import DOMPurify from 'dompurify';
import Parser from 'html-react-parser';
import DocumentView from "../../common/DocumentView";
import EInvoiceDetails from "../../common/eInvoiceDetails";

import { round } from "../../utils";
import downloadFile from "../../utils/DownloadFile";
import { getTimeDifference } from "../../utils";

import { assignDocNoToBuyerInvoice, cancelBuyerEInvoice, generateBuyerEInvoice, getBuyerInvoiceById, getBuyerInvoices } from "../../services/api/buyerInvoice";
import { getBuyerInvoiceItems } from "../../services/api/buyerInvoiceItem";
import { getInvoiceDispatchMaps } from "../../services/api/invoiceDispatchMap";
import { getSellerGRNQCPunchAcceptedQtyByDispatchIds } from "../../services/api/sellerGRNQCPunch";
import { getMaterialItemsDataByBuyerReqItemIds } from "../../services/api/buyerReqItem";
import { getAdjustmentNotesByBuyerInvoiceIds } from "../../services/api/adjustmentNotes";
import { getAdjustmentReasons } from "../../services/api/adjustmentReasons";
import { getDocCopyByDocNo } from "../../services/api/docCopy";
import { getCompanyBillAddrs } from "../../services/api/companyBillAddr";
import { getEwayBillByBuyerInvoiceIds, uploadEwayBill } from "../../services/api/eWayBill";
import { getDocItemReplacementLogByDocIds } from "../../services/api/docItemReplacementLog";
import { getDocItemReplacementMapByIds } from "../../services/api/docItemReplacementMap";
import { getUserById } from "../../services/api/user";
import { getBuyerPOsByDispatchNoteIds } from "../../services/api/buyerPO";
import { getBuyerInvoiceItemLableMapByBuyerInvoiceId } from "../../services/api/buyerInvoiceItemLableMap"

import CreateCreditNote from "./Components/CreateCreditNote";
import CreateDebitNote from "./Components/CreateDebitNote";
import GenerateEwayBill from "../GenerateEwayBill";
import CancelBuyerInvoiceModal from "./Components/CancelBuyerInvoiceModal"
import UploadEWayBill from "./Components/uploadEWayBill";
import DownloadInvoice from "./Components/DownloadInvoice";
import CreateInternalTransferInvoice from "./Components/CreateInternalTransferInvoice";
import ConfirmGenerateInvoice from "./Components/ConfirmGenerateInvoice";
import BuyerPOAndInvoiceSplitView from "./Components/BuyerPOAndInvoiceSplitView";

import { raiseToast } from '../../services/redux/reducers/toast/toast';
import { fetchHSNMasterData, fetchStates, fetchCompanyWarehouses } from "../../services/redux/reducers/commonThunk";
import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";
import { searchIncrementalReqLogs } from "../../services/api/incrementalReqLogs";
import { getBulkDeliveryChallanDocs } from "../../services/api/deliveryChallan";
import { getClientBranchEmailCCMapByCompanyIdAndBranchId, insertClientBranchEmailCCMap } from "../../services/api/clientBranchEmailCCMap";


function InvoiceDocumentNew() {
    const { buyerInvoiceId } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [eWayBill, setEWayBill] = useState({})
    const [buyerInvoice, setBuyerInvoice] = useState(null)
    const [internalTransferInvoice, setInternalTransferInvoice] = useState(null)
    const [buyerInvoiceItems, setBuyerInvoiceItems] = useState([])
    const [buyerInvoiceDisplayItems, setBuyerInvoiceDisplayItems] = useState([])
    const [companyBillAddresses, setCompanyBillAddresses] = useState([])

    const [pmCompanyBillAddrDetails, setPMCompanyBillAddrDetails] = useState({})
    const [PMBankAccountDetails, setPMBankAccountDetails] = useState({})
    const [buyerBillAddrDetails, setBuyerBillAddrDetails] = useState({})
    const [buyerInvoicePdfURL, setBuyerInvoicePdfURL] = useState('')
    const [documentHTML, setDocumentHTML] = useState('')
    const [buyerShipAddrDetails, setBuyerShipAddrDetails] = useState({})
    const [buyerInvoiceItemsPIPunchForCN, setBuyerInvoiceItemsPIPunchForCN] = useState([])
    const [buyerInvoiceItemsPIPunchForDN, setBuyerInvoiceItemsPIPunchForDN] = useState([])
    const [buyerCreditNotes, setBuyerCreditNotes] = useState([])
    const [buyerDebitNotes, setBuyerDebitNotes] = useState([])
    const [displayAdjsutmentNotes, setDisplayAdjsutmentNotes] = useState([])
    const [materialDetails, setMaterialDetails] = useState([])
    const [adjustmentReasons, setAdjustmentReasons] = useState([])
    const [docItemReplacementLog, setDocItemReplacementLog] = useState([])
    const [docItemReplacementMap, setDocItemReplacementMap] = useState([])
    const [eWayBillInvoiceObj, setEWayBillInvoiceObj] = useState({})
    const [eWayBillProductDetails, setEWayBillProductDetails] = useState([])
    const [pmBillAddresses, setPMBillAddresses] = useState([])
    const [warehouseShipAddresses, setWarehouseShipAddresses] = useState([])
    const [procmartStates, setProcmartStates] = useState([])
    const [isBPOandInvoiceSplitViewVisible, setIsBPOandInvoiceSplitViewVisible] = useState(false)
    const [buyerPOs, setBuyerPOs] = useState([])
    const [buyerPODocPDFs, setBuyerPODocPDFs] = useState([])
    const [selectedBuyerPODocNo, setSelectedBuyerPODocNo] = useState(null)
    const [buyerInvoiceItemLableMaps, setBuyerInvoiceItemLableMaps] = useState([])

    const [isCreateCreditNoteVisible, setIsCreateCreditNoteVisible] = useState(false)
    const [isCreateDebitNoteVisible, setIsCreateDebitNoteVisible] = useState(false)
    const [isEwayBillVisible, setIsEwayBillVisible] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isPDFLoading, setIsPDFLoading] = useState(false)
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [visibleViewAdjustmentNote, setVisibleViewAdjustmentNote] = useState(false)
    const [cancelRemarks, setCancelRemarks] = useState('')
    const [visibleCancelBuyerInvoice, setVisibleCancelBuyerInvoice] = useState(false)
    const [isDownloadInvoiceDialogVisible, setIsDownloadInvoiceDialogVisible] = useState(false)
    const [visibleUploadEWayBill, setVisibleUploadEWayBill] = useState(false)
    const [isVisibleInternalTransferInv, setIsVisibleInternalTransferInv] = useState(false)
    const [buyerCNandDNDocItemReplacementItemLog, setBuyerCNandDNDocItemReplacementItemLog] = useState([])
    const [visibleEInvoiceDetails, setVisibleEInvoiceDetails] = useState(false)
    const [visibleInvoiceConfirmation, setVisibleInvoiceConfirmation] = useState(false)
    const [buyerUserDetails, setBuyerUserDetails] = useState([])
    const [incrementalReqLogs, setIncrementalReqLogs] = useState([])
    const [clientBranchEmailCCMap, setClientBranchEmailCCMap] = useState({})

    const HSNMasterData = useSelector((state) => state.common.HSNMaster)

    const pmCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)
    const statesList = useSelector(state => state.common.states)
    const companyWarehouses = useSelector(state => state.common.companyWarehouses)

    const pmCompanyConfig = getPMCompanyConfig(buyerInvoice?.pmCompanyId)

    const actionMenu = useRef(null)

    const userId = useSelector((state) => state.userDetails.userId)

    useEffect(() => {
        getBuyerInvoice()
        dispatch(fetchHSNMasterData())
        dispatch(fetchStates())
        dispatch(fetchCompanyWarehouses())
    }, [])

    useEffect(() => {
        getEWayBill()

        if(buyerInvoice && buyerInvoice.statusId !== 6 && !buyerInvoice.docNo && !isBPOandInvoiceSplitViewVisible){
            getInvoiceDispatchNoteMapData({ isCreditNoteVisible: false, isDebitNoteVisible: false, isBPOAndInvoiceSplitVisible: true })
        }

    }, [buyerInvoice])

    useEffect(() => {
        if (statesList?.length) {
            getProcmartStates()
        }
    }, [statesList])

    let canCreateCreditNote = false
    if (buyerInvoice?.IRN || ![1, 3, 4].includes(buyerInvoice?.supplyTypeId)) {
        canCreateCreditNote = true
    }

    let canInvoiceDownloaded = false
    if ([1, 3, 4].includes(buyerInvoice?.supplyTypeId) && buyerInvoice?.IRN) {
        canInvoiceDownloaded = true
    }
    if ([2].includes(buyerInvoice?.supplyTypeId)) {
        canInvoiceDownloaded = true
    }

    if (buyerInvoice?.statusId === 6) { // CANCELLED
        canInvoiceDownloaded = true
        canCreateCreditNote = false
    }

    if(!pmCompanyConfig.isEInvoiceRequired && buyerInvoice?.docNo){
        canInvoiceDownloaded = true
    }

    if(!pmCompanyConfig.isEInvoiceRequired && buyerInvoice?.docNo && buyerInvoice.statusId === 1){
        canCreateCreditNote = true
    }

    let timeDifference = getTimeDifference(buyerInvoice?.createdAt, new Date())


    let permissions = []
    if (timeDifference < 24) {
        //permissions = [39]
    }
    if (buyerInvoice?.docNo) {
        permissions = [40]
    }

    const getProcmartStates = async () => {
        const procmartBillAddrIds = _.map(pmCompanyDetails.companyBranches, 'primaryBillAddrId')
        const allPrimaryBillAddrIds = _.uniq(procmartBillAddrIds)

        const billAddrRes = await getCompanyBillAddrs({ billAddrIds: allPrimaryBillAddrIds, paginator: false })
        if (billAddrRes.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'billAddrRes', detail: billAddrRes.data.error, life: 3000 }))
        }
        setPMBillAddresses(billAddrRes?.data?.data)

        const companyWarehouseShipAddrsIds = pmCompanyDetails.companyWarehouses.map(eachWareHouse => eachWareHouse.shipAddrId)
        const shipAddresses = pmCompanyDetails.companyBranchShipAddrs.filter(eachAddr => companyWarehouseShipAddrsIds.includes(eachAddr.shipAddrId))
        setWarehouseShipAddresses(shipAddresses)

        const allStateIds = billAddrRes?.data?.data.map(eachBillAddr => eachBillAddr.stateId)
        const filteredStates = statesList?.filter(eachState => allStateIds.includes(eachState.stateId))
        setProcmartStates(filteredStates)
    }

    const actionMenuItems = [
        {
            label: "Compare BuyerPO & Invoice",
            visible: buyerInvoice && buyerInvoice.statusId !== 6 && !buyerInvoice.docNo,
            command: () => {
                handleOnClickCompareBPOandInvoice()
            },
        },
        {
            label: "Generate Invoice & E-invoice",
            visible: buyerInvoice?.statusId !== 6 && [1, 3, 4].includes(buyerInvoice?.supplyTypeId) && !buyerInvoice?.IRN && pmCompanyConfig.isEInvoiceRequired,
            command: () => {
                handleGenerateBuyerEInvoice()
            },
            permissions: [44]
        },
        {
            label: "Generate Invoice",
            visible: buyerInvoice?.statusId !== 6 && [1, 3, 4].includes(buyerInvoice?.supplyTypeId) && !buyerInvoice?.docNo && !pmCompanyConfig.isEInvoiceRequired,
            command: () => {
                handleAssignDocNoToBuyerInvoice()
            },
            permissions: [44]
        },
        {
            label: isPDFLoading ? "Loading..." : 'Download Buyer Invoice',
            visible: canInvoiceDownloaded,
            command: () => setIsDownloadInvoiceDialogVisible(true)
        },
        {
            label: 'Create Credit Note',
            visible: canCreateCreditNote,
            command: async () => {
                setIsLoading(true)
                await getAdjustmentReasonsData()
                await getInvoiceDispatchNoteMapData({ isCreditNoteVisible: true, isDebitNoteVisible: false, isBPOAndInvoiceSplitVisible: false })
            },
            permissions: [41]
        },
        {
            label: 'View Credit Notes',
            visible: buyerCreditNotes.length > 0,
            command: () => { setVisibleViewAdjustmentNote(true); setDisplayAdjsutmentNotes(buyerCreditNotes) }
        },
        {
            label: 'Create Debit Note',
            visible: canCreateCreditNote,
            command: async () => {
                setIsLoading(true)
                await getInvoiceDispatchNoteMapData({ isDebitNoteVisible: true, isCreditNoteVisible: false, isBPOAndInvoiceSplitVisible: false })
            },
            permissions: [42]
        },
        {
            label: 'View Debit Notes',
            visible: buyerDebitNotes.length > 0,
            command: () => { setVisibleViewAdjustmentNote(true); setDisplayAdjsutmentNotes(buyerDebitNotes) }
        },
        {
            label: 'Generate E-Way Bill',
            visible: !eWayBill.length && canCreateCreditNote && !pmCompanyConfig.isInternational,
            //disabled: true,
            command: () => handleGenerateEwayBill(),
            permissions: [43],
        },
        {
            label: 'View E-Way Bill',
            visible: eWayBill.length ? true : false,
            command: () => { navigate(`/Eway_bill_document/${eWayBill[0]?.ewayBillId}`) }
        },
        {
            label: "Upload E-Way Bill",
            visible: !eWayBill.length && canCreateCreditNote && !pmCompanyConfig.isInternational,
            command: () => setVisibleUploadEWayBill(true),
            permissions: [43],
        },
        {
            label: 'Download Delivery Challans',
            visible: true,
            command: () => {downloadDeliveryChallans()}
        },
        {
            label: 'Create Internal Transfer',
            visible: !internalTransferInvoice && canCreateCreditNote && !pmCompanyConfig.isInternational,
            command: () => setIsVisibleInternalTransferInv(true)
        },
        {
            label: 'View Internal Transfer',
            visible: internalTransferInvoice ? true : false,
            command: () => { window.open(`/buyerInvoice/${internalTransferInvoice?.buyerInvoiceId}`, '_blank') }
        },
        {
            label: !buyerInvoice?.docNo ? "Cancel Preview Invoice" : 'Cancel Invoice',
            visible: !(buyerCreditNotes.length || buyerDebitNotes.length || incrementalReqLogs.length) && buyerInvoice?.statusId !== 6 ? true : false, // if incremental log exists this should be diabled 
            command: () => setVisibleCancelBuyerInvoice(true),
            permissions: permissions,
            className: "cancel-btn"
        },
        {
            label: "Regenerate Document",
            className: "",
            command: () => regenerateDocCopy(),            
            permissions: [102],
            visible: [1, 6].includes(buyerInvoice?.statusId) && [1, 3, 4].includes(buyerInvoice?.supplyTypeId) && (buyerInvoice?.IRN ? true : false),
            disabled: isLoading || isPDFLoading || isPageLoading
        }
    ]

    const handleOnClickCompareBPOandInvoice = async() => {
        if(buyerPOs.length){
            setIsBPOandInvoiceSplitViewVisible(true)
        }else{
            await getInvoiceDispatchNoteMapData({ isCreditNoteVisible: false, isDebitNoteVisible: false, isBPOAndInvoiceSplitVisible: true })
        }
    }

    const regenerateDocCopy = async () => {
        if(!window.confirm("Confirm to regenerate document")){
            return
        }

        setIsLoading(true)

        const createNewDocCopy = true
        const docCopyRes = await getDocCopyByDocNo(buyerInvoice.docNo, null, createNewDocCopy)

        if(docCopyRes.failure){
            dispatch(raiseToast({severity:'error', detail: docCopyRes.data.error, life: 3000}))
        }else{
            setBuyerInvoicePdfURL(docCopyRes?.docLocation)
        }

        setIsLoading(false)
    }

    const downloadDeliveryChallans = async () => {
        setIsLoading(true)

        const docCopyRes = await getBulkDeliveryChallanDocs({buyerInvoiceId: buyerInvoice.buyerInvoiceId})

        if(docCopyRes.failure){
            dispatch(raiseToast({severity:'error', detail: docCopyRes.data.error}))
        }else{
            docCopyRes.data.map(eachDocCopy => {
                downloadFile(eachDocCopy.docLocation, `Delivery_Challan_${eachDocCopy.docNo}.pdf`)
            })
        }

        setIsLoading(false)
    }

    const getBuyerInvoicePDFURL = async () => {
        setIsPDFLoading(true)

        const docCopyRes = await getDocCopyByDocNo(buyerInvoice.docNo, true)

        if (docCopyRes.failure) {
            setIsPDFLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: "Buyer Invoice Document", detail: docCopyRes.data.error, life: 3000 }))
        }

        if (docCopyRes?.docLocation) {
            setIsPDFLoading(false)
            setBuyerInvoicePdfURL(docCopyRes?.docLocation)
        }

        downloadFile(docCopyRes.docLocation, `invoice_${buyerInvoice.docNo}.pdf`)
        setIsPDFLoading(false)
    }

    const getEWayBill = async () => {
        const ewayBillRes = await getEwayBillByBuyerInvoiceIds({ buyerInvoiceIds: [buyerInvoice?.buyerInvoiceId] })
        if (ewayBillRes.failure) {
            dispatch(raiseToast({ severity: 'error', summary: "E-Way Bill", detail: ewayBillRes.data.error, life: 3000 }))
        } else {
            console.log("eWayBill", ewayBillRes)
            setEWayBill(ewayBillRes?.data)
        }
    }

    const handleAssignDocNoToBuyerInvoice = async () => {
        setIsLoading(true)
        const buyerInvoiceRes = await assignDocNoToBuyerInvoice(buyerInvoice.buyerInvoiceId)
        setIsLoading(false)

        if (buyerInvoiceRes.failure) {
            dispatch(raiseToast({ severity: 'error', summary: "Doc No Assignment", detail: buyerInvoiceRes.data.error }))
        } else {
            console.log("handleAssignDocNoToBuyerInvoice", buyerInvoiceRes)
            getBuyerInvoice()
            //setBuyerInvoice({...buyerInvoice, docNo: buyerInvoiceRes.data.docNo, fileNo: buyerInvoiceRes.data.fileNo})
        }
    }

    const handleCancelBuyerInvoice = async () => {
        const createdDate = moment(buyerInvoice.createdAt)
        const currentDate = moment(new Date())
        const duration = currentDate.diff(createdDate, 'hours')

        /*if (buyerInvoice.docNo) {
            if (![2].includes(buyerInvoice.supplyTypeId) && buyerInvoice.IRN && duration > 24) {
                return dispatch(raiseToast({ severity: 'error', detail: "Cant cancel invoice past 24 hours of generation", life: 3000 }))
            } else if ([2].includes(buyerInvoice.supplyTypeId) && duration > 24) {
                return dispatch(raiseToast({ severity: 'error', detail: "Cant cancel invoice past 24 hours of generation", life: 3000 }))
            }
        }*/

        if (!window.confirm("Confirm to cancel the invoice.")) {
            return
        }
        setIsLoading(true)
        setVisibleCancelBuyerInvoice(false)
        const buyerInvoiceResponse = await cancelBuyerEInvoice(buyerInvoiceId, { cancelRemarks: cancelRemarks })
        console.log("buyerInvoiceResponse", buyerInvoiceResponse)

        if (buyerInvoiceResponse.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: buyerInvoiceResponse.data.error, life: 3000 }))
        }
        else {
            setBuyerInvoice(buyerInvoiceResponse.data?.buyerInvoice)
            if (buyerInvoiceResponse.data?.docCopy?.docLocation) {
                setBuyerInvoicePdfURL(buyerInvoiceResponse.data?.docCopy?.docLocation)
            }
            dispatch(raiseToast({ severity: 'success', detail: "Invoice cancelled successfully", life: 3000 }))
        }
        setCancelRemarks('')
        setIsLoading(false)
    }

    const throttledCancelBuyerInvoice = _.throttle(handleCancelBuyerInvoice, 15000, { leading: true, trailing: false })

    const handleGenerateEwayBill = () => {
        let productDetails = []
        buyerInvoiceItems?.map(eachBuyerInvoiceItem => {
            let isIGST = pmCompanyBillAddrDetails.stateId === buyerBillAddrDetails.stateId ? false : true

            if([3, 4].includes(buyerInvoice.supplyTypeId)){
                isIGST = true
            }

            const IGSTTaxRate = isIGST ? eachBuyerInvoiceItem?.GSTRate : 0
            const IGSTTax = IGSTTaxRate * eachBuyerInvoiceItem?.itemAmountBeforeTax * 0.01
            const CGSTTaxRate = !isIGST ? (eachBuyerInvoiceItem?.GSTRate / 2) : 0
            const CGSTTax = CGSTTaxRate * eachBuyerInvoiceItem?.itemAmountBeforeTax * 0.01
            const SGSTTaxRate = !isIGST ? (eachBuyerInvoiceItem?.GSTRate / 2) : 0
            const SGSTTax = SGSTTaxRate * eachBuyerInvoiceItem?.itemAmountBeforeTax * 0.01
            let newProduct = {
                materialId: eachBuyerInvoiceItem?.materialId,
                HSNCode: eachBuyerInvoiceItem?.HSNCode,
                qty: eachBuyerInvoiceItem?.qty,
                unitPrice: eachBuyerInvoiceItem?.unitPrice,
                itemAmountBeforeTax: eachBuyerInvoiceItem?.itemAmountBeforeTax,
                itemAmountWithTax: eachBuyerInvoiceItem?.itemAmountWithTax,
                GSTRate: eachBuyerInvoiceItem?.GSTRate,
                IGSTTax: round(IGSTTax),
                IGSTTaxRate: round(IGSTTaxRate),
                CGSTTax: round(CGSTTax),
                CGSTTaxRate: CGSTTaxRate,
                SGSTTax: round(SGSTTax),
                SGSTTaxRate: SGSTTaxRate,
                buyerReqItemId: eachBuyerInvoiceItem?.buyerReqItemId
            }
            productDetails.push(newProduct)
        })
        let invoiceObj = { ...buyerInvoice }
        setEWayBillInvoiceObj(invoiceObj)
        setEWayBillProductDetails(productDetails)
        setIsEwayBillVisible(true)
    }

    const handleGenerateBuyerEInvoice = async () => {

        let updatedBuyerInvoiceItems = buyerInvoiceItems.map(eachInvoiceItem => {
            docItemReplacementMap?.map(eachMap => {
                const relatedDocItemReplacementLog = docItemReplacementLog?.find(eachReplaceLogItem => eachReplaceLogItem?.docItemReplacementMapId === eachMap?.docItemReplacementMapId)
                if (relatedDocItemReplacementLog) {
                    let relatedMaterialReplacedQty = eachMap?.toReplace[eachInvoiceItem?.materialId]
                    if (relatedMaterialReplacedQty) {
                        eachInvoiceItem.isReplacedItem = true
                    }
                }
            })
            return eachInvoiceItem
        })

        const invalidHSNCodes = []

        updatedBuyerInvoiceItems.map(eachInvoiceItem => {
            if (!eachInvoiceItem.isReplacedItem) {
                const relatedHSNMasterCode = HSNMasterData.find(eachHSNDetail => eachHSNDetail.HSNCode === eachInvoiceItem.HSNCode)
                if (!relatedHSNMasterCode) {
                    invalidHSNCodes.push(eachInvoiceItem.HSNCode)
                }
            }
        })

        let nonBuyerReqRequirement = buyerInvoiceItems.length ? !buyerInvoiceItems[0].buyerReqItemId : null

        if (invalidHSNCodes.length) {
            return dispatch(raiseToast({ severity: 'error', detail: `HSN codes ${invalidHSNCodes.join(", ")} are invalid`, life: 3000 }))
        }
        
        if (!nonBuyerReqRequirement && !materialDetails) {
            return dispatch(raiseToast({ severity: 'error', detail: "material details not found", life: 3000 }))
        }

        const isUOMMissingInProducts = materialDetails?.some(eachMaterialDetail => !eachMaterialDetail.UOM)

        if (isUOMMissingInProducts) {
            return dispatch(raiseToast({ severity: 'error', detail: "UOM not available for some items", life: 3000 }))
        }

        if(buyerInvoice.totalAmountWithTax > 50000){
            if (!window.confirm("Confirm to geneate E-invoice.")) {
                return
            }
            throttledGenerateBuyerEInvoice()
        } else {
            setIsLoading(true)

            const buyerUserDetails = await getUserById(buyerInvoice.userId)
            if(buyerUserDetails.failure){
                return dispatch(raiseToast({ severity: 'error', detail: buyerUserDetails.data.error, life: 3000 }))
            }
            setBuyerUserDetails(buyerUserDetails.data[0])

            setIsLoading(false)
            setVisibleInvoiceConfirmation(true)
        }
    }

    const triggerBuyerEInvoice = async (emailObj) => {

        setIsLoading(true)
        setVisibleInvoiceConfirmation(false)

        const buyerEInvoiceResponse = await generateBuyerEInvoice({ buyerInvoice, buyerInvoiceItems, emailObj: emailObj })
        if (buyerEInvoiceResponse.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: buyerEInvoiceResponse.data.error, life: 3000 }))
        } else {
            setVisibleInvoiceConfirmation(false)
            if (buyerEInvoiceResponse.data?.docCopy?.docLocation) {
                setBuyerInvoice(buyerEInvoiceResponse.data?.buyerInvoice)
                setBuyerInvoicePdfURL(buyerEInvoiceResponse.data?.docCopy?.docLocation)
            }
        }

        let newEmailIds = []
        if (clientBranchEmailCCMap.emailIds && emailObj && emailObj.cc) {
            emailObj.cc.forEach(eachEmail => {
                const relatedEmailId = clientBranchEmailCCMap.emailIds.find(eachClientBranchEmailCCMap => {
                    return eachClientBranchEmailCCMap === eachEmail
                })
                if (!relatedEmailId) {
                    newEmailIds.push(eachEmail)
                }
            })
        }
        else if (emailObj && emailObj.cc) {
            newEmailIds = emailObj.cc
        }

        if (newEmailIds.length) {
            let updatedClientBranchEmailCCMap = []
            if (clientBranchEmailCCMap.companyId) {
                updatedClientBranchEmailCCMap = { ...clientBranchEmailCCMap, emailIds: newEmailIds }
            }
            else {
                updatedClientBranchEmailCCMap = { companyId: buyerInvoice.companyId, branchId: buyerInvoice.branchId, emailIds: newEmailIds }
            }

            const clientBranchEmailCCMapRes = await insertClientBranchEmailCCMap({ clientBranchEmailCCMap: updatedClientBranchEmailCCMap })
            if (clientBranchEmailCCMapRes.failure) {
                dispatch(raiseToast({ severity: 'error', detail: clientBranchEmailCCMapRes.data.error }))
            }
        }

        setIsLoading(false)
    }

    const throttledGenerateBuyerEInvoice = _.throttle(triggerBuyerEInvoice, 20000, { leading: true, trailing: false })

    const getBuyerInvoice = async () => {
        setIsLoading(true)
        const buyerInvoiceResponse = await getBuyerInvoiceById(buyerInvoiceId)
        console.log("buyerInvoiceResponse", buyerInvoiceResponse)

        if (buyerInvoiceResponse.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: buyerInvoiceResponse.data.error, life: 3000 }))
        }
        else {
            setBuyerInvoice(buyerInvoiceResponse.data?.buyerInvoice)
            setCompanyBillAddresses(buyerInvoiceResponse?.data?.companyBillAddresses)
            //setCompanyShipAddress(buyerInvoiceResponse?.data?.companyShipAddress)
            await getBuyerInvoiceItemsData(buyerInvoiceResponse?.data?.buyerInvoice?.buyerInvoiceId)

            if (buyerInvoiceResponse.data?.buyerInvoice) {
                getInternalTransferInvoice(buyerInvoiceResponse.data.buyerInvoice.buyerInvoiceId)
                getClientBranchEmailCCMapByCompanyIdAndBranchIdData({companyId: buyerInvoiceResponse.data.buyerInvoice.companyId, branchId: buyerInvoiceResponse.data.buyerInvoice.branchId})
            }

            setPMCompanyBillAddrDetails(buyerInvoiceResponse?.data?.pmCompanyBillAddrDetails)
            setBuyerBillAddrDetails(buyerInvoiceResponse?.data?.buyerBillAddrDetails)
            setDocumentHTML(buyerInvoiceResponse?.data?.documentHTML)
            setBuyerInvoicePdfURL(buyerInvoiceResponse?.data?.buyerInvoicePdfURL)
            setBuyerShipAddrDetails(buyerInvoiceResponse?.data?.buyerShipAddrDetails)
            setPMBankAccountDetails(buyerInvoiceResponse?.data?.PMBankAccountDetails)
        }
        setIsLoading(false)
    }

    const getClientBranchEmailCCMapByCompanyIdAndBranchIdData = async (data) => {
        const {companyId, branchId} = data
        const clientBranchEmailCCMapRes = await getClientBranchEmailCCMapByCompanyIdAndBranchId({companyId, branchId})
        if (clientBranchEmailCCMapRes.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: clientBranchEmailCCMapRes.data.error }))
        }

        if(clientBranchEmailCCMapRes.data){
            setClientBranchEmailCCMap(clientBranchEmailCCMapRes.data)
        }
    }

    const getInternalTransferInvoice = async (parentInvoiceId) => {
        const internalTransferInvoiceRes = await getBuyerInvoices({ parentInvoiceIds: [parentInvoiceId] })
        console.log('internalTransferInvoiceRes', internalTransferInvoiceRes)
        if (internalTransferInvoiceRes.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: internalTransferInvoiceRes.data.error, life: 3000 }))
        }
        else {
            setInternalTransferInvoice(internalTransferInvoiceRes.data?.[0])
        }
    }

    const getAdjustmentReasonsData = async () => {
        let adjustmentReasonsResponse = await getAdjustmentReasons({ adjustmentReasonName: "ASC", paginator: false })
        console.log("adjustmentReasonsResponse===", adjustmentReasonsResponse)
        if (adjustmentReasonsResponse.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: adjustmentReasonsResponse.data.error, life: 3000 }))
        } else {
            let relatedAdjustmentReasons = adjustmentReasonsResponse?.data?.data.filter(eachAdjustmentReason => {
                if (eachAdjustmentReason.adjustmentReasonName === "Damaged" ||
                    eachAdjustmentReason.adjustmentReasonName === "Improper Specs" ||
                    eachAdjustmentReason.adjustmentReasonName === "Rejected" ||
                    eachAdjustmentReason.adjustmentReasonName === "ReInvoicing" ||
                    eachAdjustmentReason.adjustmentReasonName === "Short" ||
                    eachAdjustmentReason.adjustmentReasonName === "Price Adjustment"
                ) {
                    return true
                }
            })
            setAdjustmentReasons(relatedAdjustmentReasons)
        }
    }

    const getBuyerInvoiceItemsData = async (docId) => {
        setIsLoading(true)
        const buyerInvoiceItemsResponse = await getBuyerInvoiceItems({ buyerInvoiceIds: [buyerInvoiceId], include: [], paginator: false })
        console.log("buyerInvoiceItemsResponse===", buyerInvoiceItemsResponse, buyerInvoice)
        if (buyerInvoiceItemsResponse.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: buyerInvoiceItemsResponse.data.error, life: 3000 }))
        }

        const buyerInvoiceItemLableMaps = await getBuyerInvoiceItemLableMaps(buyerInvoiceId)

        const buyerCreditAndDebitNoteResponse = await getAdjustmentNotesByBuyerInvoiceIds({ buyerInvoiceIds: [buyerInvoiceId] })
        console.log("buyerCreditAndDebitNoteResponse===", buyerCreditAndDebitNoteResponse)
        if (buyerCreditAndDebitNoteResponse.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: buyerCreditAndDebitNoteResponse.data.error, life: 3000 }))
        }

        let docItemReplacementLogByDocIds = [buyerInvoiceId];
        let relatedBuyerCreditNotes = buyerCreditAndDebitNoteResponse?.data?.filter(eachAdjustmentNote => {
            if (eachAdjustmentNote.adjustmentTypeId === 1) {
                docItemReplacementLogByDocIds.push(eachAdjustmentNote.adjustmentNoteId);
                return true
            }
            return false
        })

        setBuyerCreditNotes(relatedBuyerCreditNotes)

        let relatedBuyerDebitNotes = buyerCreditAndDebitNoteResponse?.data?.filter(eachAdjustmentNote => {
            if (eachAdjustmentNote.adjustmentTypeId === 2) {
                docItemReplacementLogByDocIds.push(eachAdjustmentNote.adjustmentNoteId);
                return true
            }
            return false
        })

        setBuyerDebitNotes(relatedBuyerDebitNotes)

        //const docItemReplacementLogRes = await getDocItemReplacementLogByDocId({ docId : docId})
        const docItemReplacementLogRes = await getDocItemReplacementLogByDocIds({ docItemReplacementLogDocIds: docItemReplacementLogByDocIds })
        console.log("docItemReplacementLogRes", docItemReplacementLogRes)

        if (docItemReplacementLogRes?.failure) {
            return dispatch(raiseToast({ severity: 'error', summary: 'Doc item replacement log', detail: docItemReplacementLogRes.data.error, life: 3000 }))
        }

        const relatedBuyerReqIds = buyerInvoiceItemsResponse.data.map(eachBuyerInvoiceItem => eachBuyerInvoiceItem.buyerReqId)
        const incrementalReqLogRes = await searchIncrementalReqLogs({ buyerReqIds: relatedBuyerReqIds })
        
        if (incrementalReqLogRes.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: incrementalReqLogRes.data.error }))
        }
        //setIncrementalReqLogs(incrementalReqLogRes.data)

        const relatedDocItemReplacementMapIds = docItemReplacementLogRes?.data?.map(eachDocItemLog => eachDocItemLog?.docItemReplacementMapId)
        let relatedDocItemReplacementMapRes
        if (docItemReplacementLogRes?.data?.length > 0) {
            relatedDocItemReplacementMapRes = await getDocItemReplacementMapByIds({ docItemReplacementMapIds: relatedDocItemReplacementMapIds })
            console.log("relatedDocItemReplacementMapRes", relatedDocItemReplacementMapRes)
        }

        if (relatedDocItemReplacementMapRes?.failure) {
            return dispatch(raiseToast({ severity: 'error', summary: 'Doc Item replacement map', detail: relatedDocItemReplacementMapRes.data.error, life: 3000 }))
        }

        let buyerInvoiceDocItemReplacementLog = docItemReplacementLogRes?.data?.filter(eachDocItemReplacementLog => eachDocItemReplacementLog.docId === parseInt(buyerInvoiceId))
        let replacedCNDNDocItemReplacementLog = docItemReplacementLogRes?.data?.filter(eachDocItemReplacementLog => eachDocItemReplacementLog.docId !== parseInt(buyerInvoiceId))

        let unreplacedBuyerInvoiceItems = []
        let replacedProducts = []

        let buyerInvoiceItemsRes = []
        if (buyerInvoiceItemsResponse?.data) {
            buyerInvoiceItemsRes = JSON.parse(JSON.stringify(buyerInvoiceItemsResponse?.data))
        }
        relatedDocItemReplacementMapRes?.data?.map(eachReplaceMapItem => {
            const relatedDocItemReplacementLog = buyerInvoiceDocItemReplacementLog.find(eachReplaceLogItem => eachReplaceLogItem?.docItemReplacementMapId === eachReplaceMapItem?.docItemReplacementMapId)

            let totalReplacedCreditNoteQty = 0
            let totalReplacedDebitNoteQty = 0

            if (replacedCNDNDocItemReplacementLog?.length > 0 && relatedDocItemReplacementLog) {
                replacedCNDNDocItemReplacementLog.map(eachReplaceLogItem => {
                    if (eachReplaceLogItem.docItemReplacementMapId === relatedDocItemReplacementLog.docItemReplacementMapId) {
                        relatedBuyerCreditNotes?.map(eachCreditNote => {
                            if ((eachCreditNote.statusId === 1 || eachCreditNote.statusId === 7) && eachCreditNote.adjustmentNoteId === eachReplaceLogItem.docId) {
                                totalReplacedCreditNoteQty += eachReplaceLogItem.qtyReplaced
                            }
                        })

                        relatedBuyerDebitNotes?.map(eachDebitNote => {
                            if ((eachDebitNote.statusId === 1 || eachDebitNote.statusId === 7) && eachDebitNote.adjustmentNoteId === eachReplaceLogItem.docId) {
                                totalReplacedDebitNoteQty += eachReplaceLogItem.qtyReplaced
                            }
                        })
                    }
                })
            }

            let replacedBuyerInvoiceItems = []
            buyerInvoiceItemsRes?.map(eachBuyerInvoiceItem => {
                let relatedMaterialReplacedQty = eachReplaceMapItem?.toReplace[eachBuyerInvoiceItem?.materialId]

                let totalReplacedBuyerInvoiceItemCNDNQty = 0
                if (relatedMaterialReplacedQty) {
                    totalReplacedBuyerInvoiceItemCNDNQty = round((totalReplacedCreditNoteQty * relatedMaterialReplacedQty) + (totalReplacedDebitNoteQty * relatedMaterialReplacedQty))
                    let availableReplaceBuyerINvoiceItemCNQty = round((relatedDocItemReplacementLog?.qtyReplaced * relatedMaterialReplacedQty) - totalReplacedBuyerInvoiceItemCNDNQty)
                    replacedBuyerInvoiceItems.push({
                        ...eachBuyerInvoiceItem,
                        creditNoteProductQuantity: 0,
                        debitNoteProductQuantity: 0,
                        qty: round(relatedDocItemReplacementLog?.qtyReplaced * relatedMaterialReplacedQty),
                        availableCreditNoteQty: availableReplaceBuyerINvoiceItemCNQty,
                        availableDebitNoteQty: round((relatedDocItemReplacementLog?.qtyReplaced * relatedMaterialReplacedQty) - (totalReplacedDebitNoteQty * relatedMaterialReplacedQty))
                    })
                } else {
                    let relatedReplaceMapItem = relatedDocItemReplacementMapRes?.data?.find(eachDocItemReplaceMap => eachDocItemReplaceMap.toReplace.hasOwnProperty(eachBuyerInvoiceItem.materialId));
                    let existedUnReplacedProduct = unreplacedBuyerInvoiceItems.find(eachUnreplacedItem => eachUnreplacedItem.buyerReqItemId === eachBuyerInvoiceItem.buyerReqItemId)

                    if (!existedUnReplacedProduct && !eachBuyerInvoiceItem.isReplacedItem && !relatedReplaceMapItem) {
                        unreplacedBuyerInvoiceItems.push(eachBuyerInvoiceItem)
                    }
                }

                if (relatedMaterialReplacedQty && relatedMaterialReplacedQty !== eachBuyerInvoiceItem?.qty) {
                    let existedUnReplacedProduct = unreplacedBuyerInvoiceItems.find(eachUnreplacedItem => eachUnreplacedItem.buyerReqItemId === eachBuyerInvoiceItem.buyerReqItemId)
                    if (existedUnReplacedProduct) {
                        let unreplacedQty = round(parseFloat(existedUnReplacedProduct?.qty) - (parseFloat(relatedMaterialReplacedQty) * relatedDocItemReplacementLog?.qtyReplaced))

                        let itemAmountBeforeTax = parseFloat(unreplacedQty) * parseFloat(eachBuyerInvoiceItem?.unitPrice)
                        eachBuyerInvoiceItem.qty = unreplacedQty
                        existedUnReplacedProduct.qty = unreplacedQty
                        existedUnReplacedProduct.itemAmountBeforeTax = itemAmountBeforeTax
                        existedUnReplacedProduct.itemAmountWithTax = itemAmountBeforeTax + (itemAmountBeforeTax * parseFloat(eachBuyerInvoiceItem?.GSTRate) * 0.01)
                        eachBuyerInvoiceItem = {
                            ...existedUnReplacedProduct,
                            qty: unreplacedQty + totalReplacedBuyerInvoiceItemCNDNQty,
                            itemAmountBeforeTax: itemAmountBeforeTax,
                            itemAmountWithTax: itemAmountBeforeTax + (itemAmountBeforeTax * parseFloat(eachBuyerInvoiceItem?.GSTRate) * 0.01)
                        }
                    } else {
                        let unreplacedQty = round(parseFloat(eachBuyerInvoiceItem?.qty) - (parseFloat(relatedMaterialReplacedQty) * relatedDocItemReplacementLog?.qtyReplaced))
                        let itemAmountBeforeTax = parseFloat(unreplacedQty) * parseFloat(eachBuyerInvoiceItem?.unitPrice)
                        eachBuyerInvoiceItem.qty = unreplacedQty

                        eachBuyerInvoiceItem = {
                            ...eachBuyerInvoiceItem,
                            //qty: unreplacedQty + totalReplacedBuyerInvoiceItemCNDNQty,
                            qty: unreplacedQty === 0 ? unreplacedQty : unreplacedQty + totalReplacedBuyerInvoiceItemCNDNQty,
                            itemAmountBeforeTax: itemAmountBeforeTax,
                            itemAmountWithTax: itemAmountBeforeTax + (itemAmountBeforeTax * parseFloat(eachBuyerInvoiceItem?.GSTRate) * 0.01)
                        }

                        unreplacedBuyerInvoiceItems.push(eachBuyerInvoiceItem)
                    }

                }
            })

            let itemAmountBeforeTax = parseFloat(relatedDocItemReplacementLog?.qtyReplaced) * parseFloat(eachReplaceMapItem?.unitPrice)
            replacedProducts.push(
                {
                    productName: eachReplaceMapItem?.replaceByName,
                    productSpecification: eachReplaceMapItem?.replaceByDesc,
                    HSNCode: eachReplaceMapItem?.HSNCode,
                    unitPrice: relatedDocItemReplacementLog?.unitPrice,
                    creditNoteUnitPrice: relatedDocItemReplacementLog?.unitPrice,
                    debitNoteUnitPrice: relatedDocItemReplacementLog?.unitPrice,
                    GSTRate: relatedDocItemReplacementLog?.GSTRate,
                    qty: relatedDocItemReplacementLog?.qtyReplaced,
                    availableCreditNoteQty: round(relatedDocItemReplacementLog?.qtyReplaced - totalReplacedCreditNoteQty + totalReplacedDebitNoteQty),
                    availableDebitNoteQty: round(relatedDocItemReplacementLog?.qtyReplaced - totalReplacedDebitNoteQty),
                    creditNoteProductQuantity: 0,
                    debitNoteProductQuantity: 0,
                    UOM: eachReplaceMapItem?.UOM,
                    itemAmountBeforeTax: itemAmountBeforeTax,
                    itemAmountWithTax: itemAmountBeforeTax + itemAmountBeforeTax * parseFloat(relatedDocItemReplacementLog?.GSTRate) * 0.01,
                    isReplaced: true,
                    toReplace: eachReplaceMapItem?.toReplace,
                    replacedBuyerInvoiceItemId: uuid(),
                    docItemReplacementMapId: eachReplaceMapItem?.docItemReplacementMapId,
                    relatedDocItemReplacementLog: relatedDocItemReplacementLog,
                    replacedBuyerInvoiceItems: JSON.parse(JSON.stringify(replacedBuyerInvoiceItems))
                }
            )
        })

        let buyerReqItemsIds = buyerInvoiceItemsResponse?.data?.map(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerReqItemId)
        let materialItemsDataByBuyerReqItemIdsResponse
        if (buyerReqItemsIds?.length > 0 && buyerReqItemsIds[0]) {
            materialItemsDataByBuyerReqItemIdsResponse = await getMaterialItemsDataByBuyerReqItemIds({ buyerReqItemsIds })
        }

        if (materialItemsDataByBuyerReqItemIdsResponse?.failure) {
            setIsLoading(false)
            dispatch(raiseToast({ severity: 'error', detail: materialItemsDataByBuyerReqItemIdsResponse.data.error, life: 3000 }))
        } else {
            setMaterialDetails(materialItemsDataByBuyerReqItemIdsResponse?.data)
        }

        if (!relatedDocItemReplacementMapRes || relatedDocItemReplacementMapRes?.data?.length === 0) {
            unreplacedBuyerInvoiceItems = buyerInvoiceItemsRes
        }

        let unreplacedProducts = []
        unreplacedBuyerInvoiceItems?.map(eachInvoiceItem => {
            const buyerInvoiceItemRelatedMap = relatedDocItemReplacementMapRes?.data?.find(eachReplaceMapItem => Object.keys(eachReplaceMapItem.toReplace).includes(eachInvoiceItem?.materialId?.toString()))

            let isItemCanBeAdded = false
            if (!buyerInvoiceItemRelatedMap && eachInvoiceItem?.qty > 0){
                isItemCanBeAdded = true
            }
            if (eachInvoiceItem?.qty > 0.05 || isItemCanBeAdded) {
                if(materialItemsDataByBuyerReqItemIdsResponse?.data){
                    let materialSpecificDetails = materialItemsDataByBuyerReqItemIdsResponse?.data?.find(eachMaterialItem => eachMaterialItem.materialId === eachInvoiceItem.materialId)
                    if (materialSpecificDetails) {
                        eachInvoiceItem.productName = materialSpecificDetails?.companyProdName ? materialSpecificDetails.companyProdName : materialSpecificDetails?.productName
                        eachInvoiceItem.productSpecification = materialSpecificDetails?.companyProdSpec ? materialSpecificDetails.companyProdSpec : materialSpecificDetails?.productSpecification
                        eachInvoiceItem.UOM = materialSpecificDetails.UOM
                        eachInvoiceItem.UOMValue = round(materialSpecificDetails.UOMValue)
                        eachInvoiceItem.companyQtyMultiplier = materialSpecificDetails.companyQtyMultiplier
                    }
                    if (materialSpecificDetails?.companyERPCode) {
                        eachInvoiceItem.productSpecification = eachInvoiceItem.productSpecification + ", item code: " + materialSpecificDetails?.companyERPCode
                    }

                    let relatedBuyerInvoiceItemLableMap = buyerInvoiceItemLableMaps.find(eachLableMap => eachLableMap.buyerInvoiceItemId === eachInvoiceItem.buyerInvoiceItemId)
                    if (relatedBuyerInvoiceItemLableMap) {
                        eachInvoiceItem.productName = relatedBuyerInvoiceItemLableMap.productName
                        eachInvoiceItem.productSpecification = relatedBuyerInvoiceItemLableMap.productSpecification
                    }
                }

                unreplacedProducts.push(eachInvoiceItem)
            }
        })

        let relatedBuyerInvoiceDisplayItems = [...unreplacedProducts, ...replacedProducts]

        let updatedBuyerInvoiceDisplayItems = relatedBuyerInvoiceDisplayItems?.map((eachBuyerInvoiceItem, index) => {
            if (eachBuyerInvoiceItem.companyQtyMultiplier) {
                //eachBuyerInvoiceItem.replacedBuyerInvoiceItems = [JSON.parse(JSON.stringify(eachBuyerInvoiceItem))]
                eachBuyerInvoiceItem.qty = round(parseFloat(eachBuyerInvoiceItem.qty) * parseFloat(eachBuyerInvoiceItem.companyQtyMultiplier))
                eachBuyerInvoiceItem.unitPrice = round(parseFloat(eachBuyerInvoiceItem.unitPrice) / eachBuyerInvoiceItem.companyQtyMultiplier)
                eachBuyerInvoiceItem.itemAmountBeforeTax = round(parseFloat(eachBuyerInvoiceItem.qty) * parseFloat(eachBuyerInvoiceItem.unitPrice))
                eachBuyerInvoiceItem.itemAmountWithTax = round(eachBuyerInvoiceItem.itemAmountBeforeTax + (parseFloat(eachBuyerInvoiceItem.itemAmountBeforeTax) * eachBuyerInvoiceItem.GSTRate * 0.01))
            }
            return eachBuyerInvoiceItem
        })

        //setDocItemReplacementLog(docItemReplacementLogRes?.data)
        setBuyerCNandDNDocItemReplacementItemLog(replacedCNDNDocItemReplacementLog)
        setDocItemReplacementLog(buyerInvoiceDocItemReplacementLog)
        setDocItemReplacementMap(relatedDocItemReplacementMapRes?.data)
        setBuyerInvoiceItems(buyerInvoiceItemsResponse?.data)
        setBuyerInvoiceDisplayItems(updatedBuyerInvoiceDisplayItems)
        setIsLoading(false)
    }

    const getInvoiceDispatchNoteMapData = async (params) => {
        const { isCreditNoteVisible, isDebitNoteVisible, isBPOAndInvoiceSplitVisible } = params
        const invoiceDispatchNoteMapResponse = await getInvoiceDispatchMaps({ buyerInvoiceIds: [buyerInvoiceId], paginator: false })
        
        if (invoiceDispatchNoteMapResponse.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: invoiceDispatchNoteMapResponse.data.error, life: 3000 }))
        }

        let relatedDispatchNoteIds = invoiceDispatchNoteMapResponse.data?.data?.map(each => each.dispatchNoteId)
        
        if (isCreditNoteVisible) {
            setIsCreateCreditNoteVisible(true)
            await getSellerGRNQCPunchAcceptedQtyByDispatchIdDataForCN(relatedDispatchNoteIds)
        }

        if (isDebitNoteVisible) {
            setIsCreateDebitNoteVisible(true)
            await getSellerGRNQCPunchAcceptedQtyByDispatchIdDataForDN(relatedDispatchNoteIds)
        }

        if(isBPOAndInvoiceSplitVisible){
            await getBuyerPOsDataByDispatchNoteIds(relatedDispatchNoteIds)
        }
    }

    const getBuyerPOsDataByDispatchNoteIds = async (dispatchNoteIds) => {
        setIsLoading(true)
        let data = {
            dispatchNoteIds
        }
        let buyerPOsAndDocNosResponse = await getBuyerPOsByDispatchNoteIds(data)
        setIsLoading(false)

        if (buyerPOsAndDocNosResponse.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: buyerPOsAndDocNosResponse.data.error, life: 3000 }))
        } else {
            if (buyerPOsAndDocNosResponse.data) {
                let {buyerPODocPDFs, buyerPOsData} = buyerPOsAndDocNosResponse.data
                setBuyerPODocPDFs([...buyerPODocPDFs])
                setBuyerPOs([...buyerPOsData])
                if(buyerPOsData.length){
                    setSelectedBuyerPODocNo(buyerPOsData[0].docNo)
                }
                setIsBPOandInvoiceSplitViewVisible(true)
            }
        }
    }

    const getBuyerInvoiceItemLableMaps = async(buyerInvoiceId) => {
        setIsLoading(true)
        let buyerInvoiceItemLableMapResponse = await getBuyerInvoiceItemLableMapByBuyerInvoiceId(buyerInvoiceId)
        console.log("buyerInvoiceItemLableMap-response", buyerInvoiceItemLableMapResponse)
        setIsLoading(false)
        if (buyerInvoiceItemLableMapResponse.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: buyerInvoiceItemLableMapResponse.data.error, life: 3000 }))
        }
        setBuyerInvoiceItemLableMaps([...buyerInvoiceItemLableMapResponse.data])
        return buyerInvoiceItemLableMapResponse.data
    }

    const calculateGRNQCPunchAcceptedQtyForCN = (buyerInvoiceItem, sellerGRNQCPunchAccpQtyData, isReplacedItem) => {
        const buyerReqItemId = buyerInvoiceItem.buyerReqItemId
        buyerInvoiceItem.creditNoteUnitPrice = buyerInvoiceItem.unitPrice

        let relatedMaterialItem = materialDetails.find(eachMaterialItem => eachMaterialItem.materialId === buyerInvoiceItem.materialId)
        if (relatedMaterialItem) {
            if (relatedMaterialItem?.companyProdName) {
                buyerInvoiceItem.productName = relatedMaterialItem?.companyProdName
            } else {
                buyerInvoiceItem.productName = relatedMaterialItem.productName
            }

            if (relatedMaterialItem?.companyProdSpec) {
                buyerInvoiceItem.productSpecification = relatedMaterialItem?.companyProdSpec
            } else {
                buyerInvoiceItem.productSpecification = relatedMaterialItem.productSpecification
            }

            if (buyerInvoiceItem.UOM) {
                buyerInvoiceItem.UOM = relatedMaterialItem.UOM
            }
        }

        let relatedBuyerInvoiceItemLableMap = buyerInvoiceItemLableMaps.find(eachLableMap => eachLableMap.buyerInvoiceItemId === buyerInvoiceItem.buyerInvoiceItemId)
        if (relatedBuyerInvoiceItemLableMap) {
            buyerInvoiceItem.productName = relatedBuyerInvoiceItemLableMap.productName
            buyerInvoiceItem.productSpecification = relatedBuyerInvoiceItemLableMap.productSpecification
        }

        if (!isReplacedItem) {
            let totalCreditNoteQty = 0
            let relatedPIPunchItemCreditNoteItems = []

            buyerCreditNotes?.map(eachCreditNote => {
                if (eachCreditNote.statusId === 1 || eachCreditNote.statusId === 7) {
                    let relatedCreditNoteItems = eachCreditNote?.adjustmentNoteItems.filter(eachCreditNoteItem => eachCreditNoteItem.buyerInvoiceItemId === buyerInvoiceItem.buyerInvoiceItemId)
                    if (relatedCreditNoteItems.length > 0) {
                        relatedCreditNoteItems.map(eachCreditNoteItem => {
                            totalCreditNoteQty += eachCreditNoteItem.adjustedQty
                            relatedPIPunchItemCreditNoteItems.push(eachCreditNoteItem)
                        })
                    }
                }
            })

            let totalDebitNoteQty = 0
            let relatedPIPunchItemDebitNoteItems = []

            buyerDebitNotes?.map(eachDebitNote => {
                if (eachDebitNote.statusId === 1 || eachDebitNote.statusId === 7) {
                    let relatedCreditNoteItems = eachDebitNote?.adjustmentNoteItems.filter(eachDebitNoteItem => eachDebitNoteItem.buyerInvoiceItemId === buyerInvoiceItem.buyerInvoiceItemId)
                    if (relatedCreditNoteItems.length > 0) {
                        relatedCreditNoteItems.map(eachDebitNoteItem => {
                            totalDebitNoteQty += eachDebitNoteItem.adjustedQty
                            relatedPIPunchItemDebitNoteItems.push(eachDebitNoteItem)
                        })
                    }
                }
            })

            const relatedPiPunchItems = sellerGRNQCPunchAccpQtyData?.filter((piPunchItem) => piPunchItem.buyerReqItemId === buyerReqItemId)

            let sellerPOItemWisePiPunchItems = []
            relatedPiPunchItems?.forEach(eachPIPunchItem => {
                const relatedSellerPOItem = sellerPOItemWisePiPunchItems.find(piPunchItem => piPunchItem.sellerPOItemId === eachPIPunchItem.sellerPOItemId)
                let totalPIPunchItemCreditNoteQty = 0
                let totalPIPunchItemDebitNoteQty = 0
                relatedPIPunchItemCreditNoteItems.map(eachCreditNote => {
                    if (eachCreditNote.sellerPIPunchItemId === eachPIPunchItem.sellerPIPunchItemId) {
                        totalPIPunchItemCreditNoteQty += eachCreditNote.adjustedQty
                    }
                })
                relatedPIPunchItemDebitNoteItems.map(eachDebitNote => {
                    if (eachDebitNote.sellerPIPunchItemId === eachPIPunchItem.sellerPIPunchItemId) {
                        totalPIPunchItemDebitNoteQty += eachDebitNote.adjustedQty
                    }
                })
                eachPIPunchItem.spoProductPiPunchCreditNoteQty = 0
                eachPIPunchItem.totalPIPunchItemCreditNoteQty = round(eachPIPunchItem.sellerPIPunchItemQty - totalPIPunchItemCreditNoteQty + totalPIPunchItemDebitNoteQty)
                if (relatedSellerPOItem) {
                    eachPIPunchItem.totalDispatchSellerPOQty = eachPIPunchItem.totalDispatchSellerPOQty + eachPIPunchItem.totalDispatchQty
                    relatedSellerPOItem.piPunchItems.push(eachPIPunchItem)
                } else {
                    const relatedSmartStockMoves = eachPIPunchItem?.smartStockMoves?.filter(eachSmartStockMove => eachSmartStockMove.materialId === eachPIPunchItem.materialId && eachSmartStockMove.consumedStockMoveDocNo === eachPIPunchItem.sellerPODocNo)

                    sellerPOItemWisePiPunchItems.push({
                        totalDispatchSellerPOQty: round(eachPIPunchItem.totalDispatchQty - totalCreditNoteQty + totalDebitNoteQty),
                        sellerPOItemId: eachPIPunchItem.sellerPOItemId,
                        sellerPOId: eachPIPunchItem.sellerPOId,
                        sellerPODocNo: eachPIPunchItem.sellerPODocNo,
                        sellerCompanyId: eachPIPunchItem.sellerCompanyId,
                        piPunchItems: [eachPIPunchItem],
                        smartStockMoves: relatedSmartStockMoves ? relatedSmartStockMoves : []
                    })
                }
            })

            if (buyerInvoiceItem.companyQtyMultiplier) {
                totalCreditNoteQty = totalCreditNoteQty * buyerInvoiceItem.companyQtyMultiplier
                totalDebitNoteQty = totalDebitNoteQty * buyerInvoiceItem.companyQtyMultiplier
            }

            buyerInvoiceItem.creditNoteProductQuantity = 0
            buyerInvoiceItem.sellerPOItems = JSON.parse(JSON.stringify(sellerPOItemWisePiPunchItems))
            buyerInvoiceItem.availableCreditNoteQty = round(buyerInvoiceItem.qty - totalCreditNoteQty + totalDebitNoteQty)
        }
        else {
            let totalReplacedCreditNoteQty = 0
            let totalReplacedDebitNoteQty = 0

            let relatedPIPunchItemCreditNoteItems = []
            let relatedPIPunchItemDebitNoteItems = []

            docItemReplacementMap.map(eachReplaceMapItem => {
                let relatedMaterialReplacedQty = eachReplaceMapItem?.toReplace[buyerInvoiceItem?.materialId]
                const relatedDocItemReplacementLog = docItemReplacementLog.find(eachReplaceLogItem => eachReplaceLogItem?.docItemReplacementMapId === eachReplaceMapItem?.docItemReplacementMapId)
                if (buyerCNandDNDocItemReplacementItemLog?.length > 0 && relatedDocItemReplacementLog) {
                    buyerCNandDNDocItemReplacementItemLog.map(eachReplaceLogItem => {
                        if (eachReplaceLogItem.docItemReplacementMapId === relatedDocItemReplacementLog.docItemReplacementMapId) {
                            buyerCreditNotes?.map(eachCreditNote => {
                                if ((eachCreditNote.statusId === 1 || eachCreditNote.statusId === 7) && eachCreditNote.adjustmentNoteId === eachReplaceLogItem.docId) {
                                    if(relatedMaterialReplacedQty){
                                        totalReplacedCreditNoteQty += round(eachReplaceLogItem.qtyReplaced * relatedMaterialReplacedQty)
                                    }else{
                                        totalReplacedCreditNoteQty += eachReplaceLogItem.qtyReplaced
                                    }
                                    relatedPIPunchItemCreditNoteItems.push(eachCreditNote)
                                }
                            })

                            buyerDebitNotes?.map(eachDebitNote => {
                                if ((eachDebitNote.statusId === 1 || eachDebitNote.statusId === 7) && eachDebitNote.adjustmentNoteId === eachReplaceLogItem.docId) {
                                    if(relatedMaterialReplacedQty){
                                        totalReplacedDebitNoteQty += round(eachReplaceLogItem.qtyReplaced * relatedMaterialReplacedQty)
                                    }else{
                                        totalReplacedDebitNoteQty += eachReplaceLogItem.qtyReplaced
                                    }
                                    relatedPIPunchItemDebitNoteItems.push(eachDebitNote)
                                }
                            })
                        }
                    })
                }
            })

            const relatedPiPunchItems = sellerGRNQCPunchAccpQtyData?.filter((piPunchItem) => piPunchItem.buyerReqItemId === buyerReqItemId)

            let sellerPOItemWisePiPunchItems = []
            relatedPiPunchItems?.forEach(eachPIPunchItem => {
                const relatedSellerPOItem = sellerPOItemWisePiPunchItems.find(piPunchItem => piPunchItem.sellerPOItemId === eachPIPunchItem.sellerPOItemId)
                let totalPIPunchItemCreditNoteQty = 0
                let totalPIPunchItemDebitNoteQty = 0
                relatedPIPunchItemCreditNoteItems.map(eachCreditNote => {
                    if (eachCreditNote.sellerPIPunchItemId === eachPIPunchItem.sellerPIPunchItemId) {
                        totalPIPunchItemCreditNoteQty += eachCreditNote.adjustedQty
                    }
                })
                relatedPIPunchItemDebitNoteItems.map(eachDebitNote => {
                    if (eachDebitNote.sellerPIPunchItemId === eachPIPunchItem.sellerPIPunchItemId) {
                        totalPIPunchItemDebitNoteQty += eachDebitNote.adjustedQty
                    }
                })

                eachPIPunchItem.spoProductPiPunchCreditNoteQty = 0
                eachPIPunchItem.totalPIPunchItemCreditNoteQty = round(eachPIPunchItem.sellerPIPunchItemQty - totalPIPunchItemCreditNoteQty + totalPIPunchItemDebitNoteQty)

                if (relatedSellerPOItem) {
                    eachPIPunchItem.totalDispatchSellerPOQty = eachPIPunchItem.totalDispatchSellerPOQty + eachPIPunchItem.totalDispatchQty
                    relatedSellerPOItem.piPunchItems.push(eachPIPunchItem)
                } else {
                    const relatedSmartStockMoves = sellerGRNQCPunchAccpQtyData?.filter(eachSmartStockMove => eachSmartStockMove.materialId === eachPIPunchItem.materialId && eachSmartStockMove.consumedStockMoveDocNo === eachPIPunchItem.sellerPODocNo)

                    sellerPOItemWisePiPunchItems.push({
                        totalDispatchSellerPOQty: round(eachPIPunchItem.totalDispatchQty - totalReplacedCreditNoteQty + totalReplacedDebitNoteQty),
                        sellerPOItemId: eachPIPunchItem.sellerPOItemId,
                        sellerPOId: eachPIPunchItem.sellerPOId,
                        sellerPODocNo: eachPIPunchItem.sellerPODocNo,
                        sellerCompanyId: eachPIPunchItem.sellerCompanyId,
                        piPunchItems: [eachPIPunchItem],
                        smartStockMoves: relatedSmartStockMoves ? relatedSmartStockMoves : []
                    })
                }
            })

            buyerInvoiceItem.sellerPOItems = JSON.parse(JSON.stringify(sellerPOItemWisePiPunchItems))
        }

        return buyerInvoiceItem
    }

    const getSellerGRNQCPunchAcceptedQtyByDispatchIdDataForCN = async (relatedDispatchNoteIds) => {
        const sellerGRNQCPunchAccpQtyResponse = await getSellerGRNQCPunchAcceptedQtyByDispatchIds(relatedDispatchNoteIds)
        console.log("sellerGRNQCPunchAccpQtyResponse===", sellerGRNQCPunchAccpQtyResponse)

        if (sellerGRNQCPunchAccpQtyResponse.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: sellerGRNQCPunchAccpQtyResponse.data.error, life: 3000 }))
        }

        if (sellerGRNQCPunchAccpQtyResponse?.data?.length === 0) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: "PIPunch not found, Please check", life: 3000 }))
        }

        let buyerInvoiceItemsPIPunchForCN = []
        buyerInvoiceDisplayItems.forEach((eachBuyerInvoiceItem) => {
            if (eachBuyerInvoiceItem?.isReplaced) {
                let calculatedreplacedBuyerInvoiceItems = []
                eachBuyerInvoiceItem?.replacedBuyerInvoiceItems?.forEach(eachReplacedBuyerInvoiceItem => {
                    let calculatedBuyerInvoiceItem = calculateGRNQCPunchAcceptedQtyForCN(eachReplacedBuyerInvoiceItem, sellerGRNQCPunchAccpQtyResponse?.data, eachBuyerInvoiceItem?.isReplaced)
                    calculatedreplacedBuyerInvoiceItems.push(calculatedBuyerInvoiceItem)
                })
                eachBuyerInvoiceItem.replacedBuyerInvoiceItems = calculatedreplacedBuyerInvoiceItems
                buyerInvoiceItemsPIPunchForCN.push(eachBuyerInvoiceItem)
            } else {
                let calculatedBuyerInvoiceItem = calculateGRNQCPunchAcceptedQtyForCN(eachBuyerInvoiceItem, sellerGRNQCPunchAccpQtyResponse?.data)
                buyerInvoiceItemsPIPunchForCN.push(calculatedBuyerInvoiceItem)
            }
        })

        setBuyerInvoiceItemsPIPunchForCN([...buyerInvoiceItemsPIPunchForCN])
        setIsLoading(false)
    }

    const calculateGRNQCPunchAcceptedQtyForDN = (buyerInvoiceItem, sellerGRNQCPunchAccpQtyData, isReplacedItem) => {
        const buyerReqItemId = buyerInvoiceItem.buyerReqItemId
        buyerInvoiceItem.debitNoteUnitPrice = buyerInvoiceItem.unitPrice

        let relatedMaterialItem = materialDetails.find(eachMaterialItem => eachMaterialItem.materialId === buyerInvoiceItem.materialId)
        if (relatedMaterialItem) {
            if (relatedMaterialItem?.companyProdName) {
                buyerInvoiceItem.productName = relatedMaterialItem?.companyProdName
            } else {
                buyerInvoiceItem.productName = relatedMaterialItem.productName
            }

            if (relatedMaterialItem?.companyProdSpec) {
                buyerInvoiceItem.productSpecification = relatedMaterialItem?.companyProdSpec
            } else {
                buyerInvoiceItem.productSpecification = relatedMaterialItem.productSpecification
            }

            if (buyerInvoiceItem.UOM) {
                buyerInvoiceItem.UOM = relatedMaterialItem.UOM
            }
        }

        let relatedBuyerInvoiceItemLableMap = buyerInvoiceItemLableMaps.find(eachLableMap => eachLableMap.buyerInvoiceItemId === buyerInvoiceItem.buyerInvoiceItemId)
        if (relatedBuyerInvoiceItemLableMap) {
            buyerInvoiceItem.productName = relatedBuyerInvoiceItemLableMap.productName
            buyerInvoiceItem.productSpecification = relatedBuyerInvoiceItemLableMap.productSpecification
        }

        if (!isReplacedItem) {

            let totalDebitNoteQty = 0
            let relatedPIPunchItemDebitNoteItems = []
            buyerDebitNotes?.map(eachDebitNote => {
                if (eachDebitNote.statusId != 6) {
                    let relatedDebitNoteItems = eachDebitNote?.adjustmentNoteItems.filter(eachDebitNoteItem => eachDebitNoteItem.buyerInvoiceItemId === buyerInvoiceItem.buyerInvoiceItemId)
                    if (relatedDebitNoteItems.length > 0) {
                        relatedDebitNoteItems.map(eachDebitNoteItem => {
                            totalDebitNoteQty += eachDebitNoteItem.adjustedQty
                            relatedPIPunchItemDebitNoteItems.push(eachDebitNoteItem)
                        })
                    }
                }
            })

            const relatedPiPunchItems = sellerGRNQCPunchAccpQtyData?.filter((piPunchItem) => piPunchItem.buyerReqItemId === buyerReqItemId)

            let sellerPOItemWisePiPunchItems = []
            relatedPiPunchItems.forEach(eachPIPunchItem => {
                let totalPIPunchItemDebitNoteQty = 0
                relatedPIPunchItemDebitNoteItems.map(eachDebitNote => {
                    if (eachDebitNote.sellerPIPunchItemId === eachPIPunchItem.sellerPIPunchItemId) {
                        totalPIPunchItemDebitNoteQty += eachDebitNote.adjustedQty
                    }
                })

                eachPIPunchItem.spoProductPiPunchDebitNoteQty = 0
                eachPIPunchItem.totalPIPunchItemDebitNoteQty = round(eachPIPunchItem.sellerPIPunchItemQty - totalPIPunchItemDebitNoteQty)

                const relatedSellerPOItem = sellerPOItemWisePiPunchItems.find(piPunchItem => piPunchItem.sellerPOItemId === eachPIPunchItem.sellerPOItemId)
                if (relatedSellerPOItem) {
                    eachPIPunchItem.totalDispatchSellerPOQty = round(eachPIPunchItem.totalDispatchSellerPOQty + eachPIPunchItem.totalDispatchQty)
                    relatedSellerPOItem.piPunchItems.push(eachPIPunchItem)
                } else {
                    sellerPOItemWisePiPunchItems.push({
                        totalDispatchSellerPOQty: round(eachPIPunchItem.totalDispatchQty - totalDebitNoteQty),
                        sellerPOItemId: eachPIPunchItem.sellerPOItemId,
                        sellerPOId: eachPIPunchItem.sellerPOId,
                        sellerPODocNo: eachPIPunchItem.sellerPODocNo,
                        piPunchItems: [eachPIPunchItem]
                    })
                }
            })

            buyerInvoiceItem.debitNoteProductQuantity = 0
            buyerInvoiceItem.sellerPOItems = sellerPOItemWisePiPunchItems
            buyerInvoiceItem.availableDebitNoteQty = round(buyerInvoiceItem.qty - totalDebitNoteQty)
        }else{

            let totalReplacedDebitNoteQty = 0

            let relatedPIPunchItemDebitNoteItems = []

            docItemReplacementMap.map(eachReplaceMapItem => {
                let relatedMaterialReplacedQty = eachReplaceMapItem?.toReplace[buyerInvoiceItem?.materialId]
                const relatedDocItemReplacementLog = docItemReplacementLog.find(eachReplaceLogItem => eachReplaceLogItem?.docItemReplacementMapId === eachReplaceMapItem?.docItemReplacementMapId)
                if (buyerCNandDNDocItemReplacementItemLog?.length > 0 && relatedDocItemReplacementLog) {
                    buyerCNandDNDocItemReplacementItemLog.map(eachReplaceLogItem => {
                        if (eachReplaceLogItem.docItemReplacementMapId === relatedDocItemReplacementLog.docItemReplacementMapId) {
                            buyerDebitNotes?.map(eachDebitNote => {
                                if ((eachDebitNote.statusId === 1 || eachDebitNote.statusId === 7) && eachDebitNote.adjustmentNoteId === eachReplaceLogItem.docId) {
                                    if(relatedMaterialReplacedQty){
                                        totalReplacedDebitNoteQty += round(eachReplaceLogItem.qtyReplaced * relatedMaterialReplacedQty)
                                    }else{
                                        totalReplacedDebitNoteQty += eachReplaceLogItem.qtyReplaced
                                    }
                                    relatedPIPunchItemDebitNoteItems.push(eachDebitNote)
                                }
                            })
                        }
                    })
                }
            })

            const relatedPiPunchItems = sellerGRNQCPunchAccpQtyData?.filter((piPunchItem) => piPunchItem.buyerReqItemId === buyerReqItemId)

            let sellerPOItemWisePiPunchItems = []
            relatedPiPunchItems?.forEach(eachPIPunchItem => {
                const relatedSellerPOItem = sellerPOItemWisePiPunchItems.find(piPunchItem => piPunchItem.sellerPOItemId === eachPIPunchItem.sellerPOItemId)
                let totalPIPunchItemDebitNoteQty = 0
                relatedPIPunchItemDebitNoteItems.map(eachDebitNote => {
                    if (eachDebitNote.sellerPIPunchItemId === eachPIPunchItem.sellerPIPunchItemId) {
                        totalPIPunchItemDebitNoteQty += eachDebitNote.adjustedQty
                    }
                })

                eachPIPunchItem.spoProductPiPunchDebitNoteQty = 0
                eachPIPunchItem.totalPIPunchItemDebitNoteQty = round(eachPIPunchItem.sellerPIPunchItemQty - totalPIPunchItemDebitNoteQty)

                if (relatedSellerPOItem) {
                    eachPIPunchItem.totalDispatchSellerPOQty = eachPIPunchItem.totalDispatchSellerPOQty + eachPIPunchItem.totalDispatchQty
                    relatedSellerPOItem.piPunchItems.push(eachPIPunchItem)
                } else {
                    sellerPOItemWisePiPunchItems.push({
                        totalDispatchSellerPOQty: round(eachPIPunchItem.totalDispatchQty - totalReplacedDebitNoteQty),
                        sellerPOItemId: eachPIPunchItem.sellerPOItemId,
                        sellerPOId: eachPIPunchItem.sellerPOId,
                        sellerPODocNo: eachPIPunchItem.sellerPODocNo,
                        piPunchItems: [eachPIPunchItem]
                    })
                }
            })

            buyerInvoiceItem.sellerPOItems = JSON.parse(JSON.stringify(sellerPOItemWisePiPunchItems))
        }

        return buyerInvoiceItem
    }

    const getSellerGRNQCPunchAcceptedQtyByDispatchIdDataForDN = async (relatedDispatchNoteIds) => {
        const sellerGRNQCPunchAccpQtyResponse = await getSellerGRNQCPunchAcceptedQtyByDispatchIds(relatedDispatchNoteIds)
        console.log("sellerGRNQCPunchAccpQty-Response", sellerGRNQCPunchAccpQtyResponse)
        if (sellerGRNQCPunchAccpQtyResponse.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: sellerGRNQCPunchAccpQtyResponse.data.error, life: 3000 }))
        }

        if (sellerGRNQCPunchAccpQtyResponse?.data?.length === 0) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: "PIPunch not found, Please check", life: 3000 }))
        }

        let buyerInvoiceItemsPIPunchForDN = []
        buyerInvoiceDisplayItems.forEach((eachBuyerInvoiceItem) => {
            if (eachBuyerInvoiceItem?.isReplaced) {
                let calculatedreplacedBuyerInvoiceItems = []
                eachBuyerInvoiceItem?.replacedBuyerInvoiceItems?.forEach(eachReplacedBuyerInvoiceItem => {
                    let calculatedBuyerInvoiceItem = calculateGRNQCPunchAcceptedQtyForDN(eachReplacedBuyerInvoiceItem, sellerGRNQCPunchAccpQtyResponse?.data, eachBuyerInvoiceItem?.isReplaced)
                    calculatedreplacedBuyerInvoiceItems.push(calculatedBuyerInvoiceItem)
                })
                eachBuyerInvoiceItem.replacedBuyerInvoiceItems = calculatedreplacedBuyerInvoiceItems
                buyerInvoiceItemsPIPunchForDN.push(eachBuyerInvoiceItem)
            } else {
                let calculatedBuyerInvoiceItem = calculateGRNQCPunchAcceptedQtyForDN(eachBuyerInvoiceItem, sellerGRNQCPunchAccpQtyResponse?.data)
                buyerInvoiceItemsPIPunchForDN.push(calculatedBuyerInvoiceItem)
            }
        })

        setBuyerInvoiceItemsPIPunchForDN([...buyerInvoiceItemsPIPunchForDN])
        setIsLoading(false)
    }

    /*
    const renderHTMLInvoiceDocument = () => {
        console.log("HTML Trigger")
        const sanitizedHTML = DOMPurify.sanitize(documentHTML)
        return(
            <div className={buyerInvoice?.statusId === 6 && "cancelled-watermark"} >
                {Parser(sanitizedHTML)}
            </div>
        )
    }
    */

    const renderHTMLInvoiceDocument = () => {
        console.log("HTML Trigger")
        let watermark = ''
        if (buyerInvoice?.statusId === 6) {
            watermark = "cancelled-watermark"
        } else if (buyerInvoice?.statusId === 1 && !buyerInvoice?.docNo) {
            watermark = 'preview-watermark'
        }
        const sanitizedHTML = DOMPurify.sanitize(documentHTML)
        /*
        return(
            <div className={buyerInvoice?.statusId === 6 && "cancelled-watermark"} >
                {Parser(sanitizedHTML)}
            </div>
        )
        */

        return (
            <div className={watermark} >
                {Parser(sanitizedHTML)}
            </div>
        )
    }

    const renderBuyerInvoicePDF = () => {
        console.log("PDF Trigger")
        return (
            <div className="" style={{ width: '210mm' }}>
                <DocumentView fileUrl={buyerInvoicePdfURL} />
            </div>
        )
    }

    const handleUploadEWayBillSubmit = async (data) => {
        data.buyerInvoiceId = buyerInvoice.buyerInvoiceId
        data.buyerInvDocNo = buyerInvoice.docNo
        data.buyerInvFileNo = buyerInvoice.fileNo

        if (window.confirm("Are you sure you want to upload E-Way Bill document")) {
            setIsLoading(true)
            const uploadEwayBillRes = await uploadEwayBill({ uploadEWayBill: data })
            if (uploadEwayBillRes.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', detail: uploadEwayBillRes.data.error, life: 3000 }))
            }

            getEWayBill()
            setVisibleUploadEWayBill(false)
            setIsLoading(false)
            dispatch(raiseToast({ severity: 'success', detail: "E-Way Bill document is successfully uploaded!", life: 3000 }))
        }
    }

    const renderBuyerPOAndInvoiceSplitViewHeader = () => {
        return (
            <div className="flex flex-row justify-content-between">
                <p>Compare BuyerPO & Invoice</p>
                <div className="col-5 flex flex-row justify-content-end align-items-center py-0">
                    <span style={{ fontSize: "13px", marginRight: "5px" }} >BuyerPO No: </span>
                    <span className=""><DropDownField options={buyerPOs} className="document-select-dropdown" optionLabel="docNo" optionValue="docNo" value={selectedBuyerPODocNo} onChange={(e) => { setSelectedBuyerPODocNo(e.value) }} /></span>
                </div>
            </div>
        )
    }

    let relatedAdjustmentNoteItems = []
    relatedAdjustmentNoteItems = buyerCreditNotes?.map(eachCreditNote => eachCreditNote.adjustmentNoteItems)

    let relatedBuyerPO = buyerPOs.find(eachBuyerPO => eachBuyerPO.docNo == selectedBuyerPODocNo)
    let relatedBuyerPODocPdf = buyerPODocPDFs.find(eachDoc => eachDoc.docNo == selectedBuyerPODocNo)
    return (
        <>
            <div className="pb-3 document-page document-page-height">
                <div className="mb-2 document-page-container">
                    <div className="flex w-auto justify-content-end">
                        <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                        <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                    </div>
                </div>
                <div className="relative document-y-scroll">
                    {
                        buyerInvoicePdfURL ? renderBuyerInvoicePDF() : renderHTMLInvoiceDocument()
                    }
                    {
                        buyerInvoice?.eInvoiceJSON ?
                            <div  className={`einvoice-qrcode-mask ${buyerInvoicePdfURL ? 'einvoice-qrcode-mask-on-pdf' : 'einvoice-qrcode-mask-on-html'}`} onClick={() => setVisibleEInvoiceDetails(true)}>
                                <i className="pi pi-eye einvoice-mask-eye text-3xl" aria-hidden="true"></i>
                            </div> : null
                    }
                </div>
            </div>
            <ViewAdjustmentNote
                type="Credit Note"
                adjustmentNote={displayAdjsutmentNotes}
                adjustmentNoteItems={relatedAdjustmentNoteItems}
                buyerInvoiceItems={buyerInvoiceItems}
                materialDetails={materialDetails}
                visibleViewAdjustmentNote={visibleViewAdjustmentNote}
                setVisibleViewAdjustmentNote={setVisibleViewAdjustmentNote}
            />
            <Dialog header="Create Credit Note" className='pi-punch-dialog create-credit-note-dialog' visible={isCreateCreditNoteVisible} style={{ height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setIsCreateCreditNoteVisible(false)}>
                <CreateCreditNote
                    userId={userId}
                    buyerInvoice={buyerInvoice}
                    buyerCreditNotes={buyerCreditNotes}
                    adjustmentReasons={adjustmentReasons}
                    buyerInvoiceItemsPIPunch={buyerInvoiceItemsPIPunchForCN}
                    setIsCreateCreditNoteVisible={setIsCreateCreditNoteVisible}
                    materialDetails={materialDetails}
                    companyWarehouses={companyWarehouses}
                />
            </Dialog>
            <Dialog header="Create Debit Note" className='pi-punch-dialog create-debit-note-dialog' visible={isCreateDebitNoteVisible} style={{ height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setIsCreateDebitNoteVisible(false)}>
                <CreateDebitNote
                    userId={userId}
                    buyerInvoice={buyerInvoice}
                    buyerDebitNotes={buyerDebitNotes}
                    buyerInvoiceItemsPIPunch={buyerInvoiceItemsPIPunchForDN}
                    setIsCreateDebitNoteVisible={setIsCreateDebitNoteVisible}
                    materialDetails={materialDetails}
                />
            </Dialog>
            <Dialog header="Generate E-Way Bill" className='pi-punch-dialog' visible={isEwayBillVisible} style={{ width: '90vw', height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setIsEwayBillVisible(false)}>
                <GenerateEwayBill
                    buyerInvoice={buyerInvoice}
                    buyerInvoiceItems={buyerInvoiceItems}
                    materialDetails={materialDetails}
                    companyBillAddresses={companyBillAddresses}
                    //companyShipAddress={companyShipAddress}
                    pmCompanyBillAddrDetails={pmCompanyBillAddrDetails}
                    buyerBillAddrDetails={buyerBillAddrDetails}
                    buyerShipAddrDetails={buyerShipAddrDetails}
                    statesList={statesList}
                    invoiceObj={eWayBillInvoiceObj}
                    productDetails={eWayBillProductDetails}
                    docType="invoice"
                />
            </Dialog>
            <Dialog header="Upload E-Way Bill" className="upload-e-way-bill-dialog" visible={visibleUploadEWayBill} style={{ width: '40vw', height: '28vh', backgroundColor: '#f8f8f8' }} onHide={() => setVisibleUploadEWayBill(false)}>
                <UploadEWayBill handleUploadEWayBillSubmit={handleUploadEWayBillSubmit} buyerInvDate={buyerInvoice?.createdAt} />
            </Dialog>
            <Dialog header="CANCEL INVOICE" className="" visible={visibleCancelBuyerInvoice} style={{ width: '30vw', minHeight: "50vh" }} onHide={() => setVisibleCancelBuyerInvoice(false)}>
                <CancelBuyerInvoiceModal handleCancelBuyerInvoice={throttledCancelBuyerInvoice} cancelRemarks={cancelRemarks} setCancelRemarks={setCancelRemarks} />
            </Dialog>
            <Dialog header="CREATE INTERNAL TRANSFER" className="create-internal-transfer-dialog" visible={isVisibleInternalTransferInv} style={{ minHeight: "70vh" }} onHide={() => setIsVisibleInternalTransferInv(false)}>
                <CreateInternalTransferInvoice buyerInvoice={buyerInvoice} procmartStates={procmartStates} pmBillAddresses={pmBillAddresses} warehouseShipAddresses={warehouseShipAddresses} setIsLoading={setIsLoading} setInternalTransferInvoice={setInternalTransferInvoice} setIsVisibleInternalTransferInv={setIsVisibleInternalTransferInv} />
            </Dialog>
            <Dialog header="DOWNLOAD INVOICE" className="" visible={isDownloadInvoiceDialogVisible} style={{ width: '35vw', minHeight: "30vh" }} onHide={() => setIsDownloadInvoiceDialogVisible(false)}>
                <DownloadInvoice buyerInvoice={buyerInvoice} buyerInvoiceItems={buyerInvoiceItems} setIsLoading={setIsLoading} eWayBill={eWayBill} docItemReplacementMap={docItemReplacementMap} buyerBillAddrDetails={buyerBillAddrDetails} />
            </Dialog>
            <Dialog header="EINVOICE DETAILS" className="" visible={visibleEInvoiceDetails} style={{ minHeight: "30vh" }} onHide={() => setVisibleEInvoiceDetails(false)}>
                <EInvoiceDetails eInvoiceDetails={buyerInvoice?.eInvoiceJSON} />
            </Dialog>
            <Dialog header="Confirmation" visible={visibleInvoiceConfirmation} style={{ width: '550px', height: '150px'}} onHide={() => setVisibleInvoiceConfirmation(false)}>
                <ConfirmGenerateInvoice throttledGenerateBuyerEInvoice={throttledGenerateBuyerEInvoice} buyerUserDetails={buyerUserDetails} clientBranchEmailCCMap={clientBranchEmailCCMap} />
            </Dialog>
            <Dialog className="buyerpo-invoice-split-dialog" header={renderBuyerPOAndInvoiceSplitViewHeader}  visible={isBPOandInvoiceSplitViewVisible} style={{ width: '90vw', height: '85vh'}} onHide={() => setIsBPOandInvoiceSplitViewVisible(false)}>
                <BuyerPOAndInvoiceSplitView 
                    buyerPOPdfURL={relatedBuyerPODocPdf ? relatedBuyerPODocPdf.docLocation : null} 
                    buyerPODocProof={relatedBuyerPO ? relatedBuyerPO.docProof : null}
                    renderHTMLInvoiceDocument={renderHTMLInvoiceDocument}
                />
            </Dialog>
            <Loading visible={isLoading} />
        </>
    )
}

export default InvoiceDocumentNew;